import { render, staticRenderFns } from "./lastComments.vue?vue&type=template&id=13bab22d&"
import script from "./lastComments.vue?vue&type=script&lang=js&"
export * from "./lastComments.vue?vue&type=script&lang=js&"
import style0 from "./lastComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports